module.exports = __webpack_public_path__ + "static/img/6.3de1b78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/6.png
// module id = axLZ
// module chunks = 0